import { render, staticRenderFns } from "./unifromOrder.vue?vue&type=template&id=eb726722&scoped=true&"
import script from "./unifromOrder.vue?vue&type=script&lang=js&"
export * from "./unifromOrder.vue?vue&type=script&lang=js&"
import style0 from "./unifromOrder.vue?vue&type=style&index=0&id=eb726722&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb726722",
  null
  
)

export default component.exports